import React from 'react'
import { useHistory } from 'react-router-dom'
import { auth } from '../../Firebase/firebase'
import { ThemeContext } from '../../Context/ThemeContext/ThemeContext'
import './UserPassword.css'

const UserPassword = () => {
  const { isLight } = React.useContext(ThemeContext)
  const history = useHistory()

  const handleLogout = () => {
    if(window.confirm("Are you sure you want to log out?")){
      auth.signOut()
        .then(() => history.push('/'))
        .catch(error => alert(error.message))
    }
  }

  return (
    <section className={`user-password`}>
      <div className={`user-password__logout  ${isLight ? "" : "dark"}`}>
        <button className="user-password__logout-btn" onClick={handleLogout}>Logout</button>
      </div>
    </section>
  )
}

export default UserPassword
